<template>
  <div class="faculty_detail p_t">
    <TopHead title="教师详情"></TopHead>
    <div class="fd_c">
      <div class="top">
        <!--<div class="t_i d_f j_s">
          <div>
            <div class="name">{{info.teacherName}}</div>
            <div class="tag" v-for="(item,index) in info.teacherTags" :key="index">{{item}}<span v-if="index<info.teacherTags.length-1">、</span></div>
          </div>
          <img :src="info.picUrl" alt="">
        </div>-->
        <div class="t_a t_i">
          <img :src="info.picUrl" alt="">
          <div class="mt_12">
            <div class="name">{{info.teacherName}}</div>
            <div class="tag" v-for="(item,index) in info.teacherTags" :key="index">{{item}}<span v-if="index<info.teacherTags.length-1">、</span></div>
          </div>
        </div>

        <div class="t_d" v-if="info.synopsis">
          <div class="td_title">教师简介</div>
          <div class="td_d" v-html="info.synopsis"></div>
        </div>
      </div>
      <div class="items_out" v-if="info.titleOne && info.contentOne">
        <div class="io_title d_f ali_c">
          <div class="or"></div>
          <span>{{info.titleOne}}</span>
        </div>
        <div>{{info.contentOne}}</div>
      </div>
      <div class="items_out" v-if="info.titleTwo && info.contentTwo">
        <div class="io_title d_f ali_c">
          <div class="or"></div>
          <span>{{info.titleTwo}}</span>
        </div>
        <div>{{info.contentTwo}}</div>
      </div>
    </div>
    <!--<div class="f_content" v-html="info.synopsis"></div>-->
  </div>
</template>

<script>
  export default {
    name: "FacultyDetail",
    data() {
      return {
        info:{},
        contentInfo:``
      }
    },
    created(){
      this.queryTeacherById()
    },
    methods: {
      queryTeacherById(){
        this.$api.queryTeacherById(this.$route.query.teacherId).then(res => {
          this.info = res.data;
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .f_content{
    ::v-deep img{
      max-width: 100%;
    }
    padding: 20px 12px 20px;
  }
  .fd_c{
    .items_out{
      >div:last-child{
        font-size: 14px;
      }
      .io_title{
        .or{
          width: 4px;
          height: 15px;
          background: #FF7B22;
          margin-right: 4px;
        }
        margin-bottom: 16px;
        font-size: 15px;
        font-weight: bold;
        color: #333333;
      }
      padding: 21px 13px 0 21px;
    }
    .top{
      .td_d{
        border: 1px dotted #BEBEBE;
        padding: 15px 13px 23px;
        font-size: 14px;
      }
      .td_title{
        font-size: 14px;
        margin-bottom: 11px;
        font-weight: bold;
        color: #333333;
      }
      .t_i{
        img{
          width: 113px;
          height: 148px;
          margin-right: 4px;
        }
        .tag{
          font-size: 12px;
          font-weight: bold;
          color: #ff8038;
        }
        .name{
          font-size: 18px;
          font-weight: bold;
          color: #333333;
          margin-bottom: 13px;
        }
      }
      border-bottom: 10px solid #F0F0F0;
      padding: 0 13px 26px;
    }
    padding: 9px 0;
  }
</style>
